import { defineMessages, IntlShape } from "react-intl";

enum BulkGroupOperation {
  ADD = "add",
  REMOVE = "remove",
}

const messages = defineMessages({
  [BulkGroupOperation.ADD]: {
    id: "bulk.operation.group.add",
    defaultMessage: "Add to groups",
    description: "Add to groups button label",
  },
  [BulkGroupOperation.REMOVE]: {
    id: "bulk.operation.group.remove",
    defaultMessage: "Remove from groups",
    description: "Remove from groups button label",
  },
});

export const getBulkGroupOperationDisplayName = (intl: IntlShape, operation: BulkGroupOperation) =>
  intl.formatMessage(messages[operation]);

export default BulkGroupOperation;
